module.exports = __webpack_public_path__ + "img/icon-sb-unbox-illustration-200x160-v2.e8cb1b4.svg";